// Lettertypen zelf gehost (via het bundelbestand) in plaats van Google Fonts:
// geen IP-adressen van bezoekers naar Google zonder toestemming (AVG), en geen
// render-blokkerende @import meer.
import "@fontsource-variable/fraunces/opsz.css";
import "@fontsource-variable/fraunces/opsz-italic.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "./index.css";
import { createRoot } from "react-dom/client";
import { App } from "./App";
const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(<App data-id="element-5750" data-mp="2f7mase7a9zxr" />);
}